import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { useUniqueWcagValues } from 'common-react';
import { NumberInput, TextFieldSize, Typography } from 'ui-components';
import { SettingsRowModel } from './RetirementCalculatorSummary.model';
import { SectionHeader } from './RetirementCalculatorSummarySection';

import useStyles from './RetirementCalculatorSummary.style';

interface SettingsSectionPropsModel {
  title: ReactNode;
  rows: SettingsRowModel[];
}

export const RetirementCalculatorSummarySettingsSection: React.FC<SettingsSectionPropsModel> = ({
  title,
  rows,
}) => {
  const c = useStyles({});
  const { getUniqueValue } = useUniqueWcagValues();

  return (
    <div className={c.section}>
      <SectionHeader title={title} />
      <div className={clsx(c.rows, c.settingsRows)}>
        {rows.map(row => {
          const inputId = getUniqueValue(`retirement-calculator-summary-${row.field}`);

          return (
            <div key={row.field} className={clsx(c.row, c.settingsRow)}>
              <label htmlFor={inputId} className={c.settingsRowLabel}>
                <Typography variant="body1" component="span" textColor="greys.60">
                  {row.label}
                </Typography>
              </label>
              <div className={c.settingsRowValue}>
                <div className={c.settingsInputWrapper}>
                  <NumberInput
                    id={inputId}
                    name={row.field}
                    className={c.settingsInput}
                    size={TextFieldSize.SMALL}
                    value={row.value}
                    decimalScale={row.decimalScale}
                    fixedDecimalScale={false}
                    disabled={row.disabled}
                    isAllowed={({ floatValue }) =>
                      floatValue === undefined || floatValue <= row.max
                    }
                    onValueChange={row.onChange}
                    onBlur={() => {
                      if (row.value === undefined || row.value < row.min) {
                        row.onChange(row.min);
                      }
                    }}
                    testId={`RetirementCalculatorSummary-${row.field}`}
                  />
                </div>
                <Typography
                  variant="body1"
                  component="span"
                  fontWeight="bold"
                  textColor="greys.60"
                  className={c.settingsUnit}
                >
                  {row.unit}
                </Typography>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
